var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Ctrl-parameter-log"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v(_vm._s(_vm.toolData.mediaName)+" atidログ")])])],1),_c('BridgeDataList',{attrs:{"type":'default'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }